



















































































































































































































































































































































































































































































































































































































import {
  defineComponent,
  onMounted,
  ref,
  reactive,
} from "@vue/composition-api";
import {
  EmployerAccountManagementApi,
  AddEmployerAccountCommand,
  EmployerAccountRightsDto2,
  EmployerAccountDto,
  UpdateEmployerAccountDetailsCommand,
  UpdateEmployerAccountRightsCommand,
  EmployerAccountRightsDto,
  UpdateEmployerAccountRightsOtherCommand,
  EmployerAccountRightsDto4,
  ProjectDto,
} from "@/api";
import router from "@/router";
import Store from "@/store";
import { mapValidationErrors } from "@/util/Forms";
import i18n from "@/i18n";

interface RightsTable {
  isEnabled: boolean;
  projectId: number;
  projectName?: string | null;
  authorize: boolean;
  confirmationMails: boolean;
  userManagement: boolean;
  subscriptionCopy: boolean;
  deleteUser: boolean;
}

enum Mode {
  EDIT,
  NEW,
  APPEND_PROJECTRIGHT_TO_EXISTING,
}

interface AutoCompleteItem {
  email: string;
  firstName: string;
  lastName: string;
  disabled: boolean;
}

/**
 * @TODO when converting this to vue3, refactor form validation for vuelidate or vee-validate
 */

export default defineComponent({
  setup(_, vm) {
    const api = new EmployerAccountManagementApi();
    const allProjects = ref<ProjectDto[]>([]);
    const userData = ref<EmployerAccountDto>({});
    const mode = ref<Mode>(Mode.NEW);
    const ownAccount = ref(true);
    let userId: number | null;

    const availableUsers = ref<EmployerAccountDto[]>([]);
    const showUserFoundDialog = ref<boolean>(false);
    const userFound = ref<EmployerAccountDto | undefined>();

    const autoComplete = ref<AutoCompleteItem[]>([]);

    const userProjectsHasProjectManagement = ref<number[]>([]);

    const userForm = reactive({
      errors: {},
      isValid: false,
      fields: {
        firstName: ref(""),
        middleName: ref(""),
        lastName: ref(""),
        emailAddress: ref(""),
        customSignature: ref(false),
        signatureLine1: ref(""),
        signatureLine2: ref(""),
        isAccountActive: ref(false),
      },
    });

    const projectRights = ref<RightsTable[] | undefined>(undefined);
    const currentProjectRights = ref<RightsTable | undefined>(undefined);
    const userRights = ref<EmployerAccountRightsDto2[] | []>([]);

    async function updateUser() {
      if (ownAccount.value === true) {
        const updateAccountDetailsRequest: UpdateEmployerAccountDetailsCommand = {
          firstName: userForm.fields.firstName,
          middleName: userForm.fields.middleName,
          lastName: userForm.fields.lastName,
          emailAddress: userForm.fields.emailAddress,
          customSignature: userForm.fields.customSignature,
          signatureLine1: userForm.fields.signatureLine1,
          signatureLine2: userForm.fields.signatureLine2,
        };

        const rightsToSubmit = [
          currentProjectRights.value as EmployerAccountRightsDto,
          ...(projectRights.value || []),
        ].filter((it) =>
          userProjectsHasProjectManagement.value.includes(it.projectId)
        );

        api
          .employerAccountManagementUpdateAccountDetails(
            updateAccountDetailsRequest
          )
          .then(() => {
            const updateAccountRightsRequest: UpdateEmployerAccountRightsCommand = {
              rights: rightsToSubmit,
            };
            api
              .employerAccountManagementUpdateAccountRights(
                updateAccountRightsRequest
              )
              .then(() => {
                // Return to user account overview
                router.push({ name: "user-management" });
              });
          })
          .catch((err) => {
            userForm.errors = err.response.data.errors;
          });
      } else {
        const rightsToSubmit = [
          currentProjectRights.value as EmployerAccountRightsDto4,
          ...(projectRights.value || []),
        ].filter((it) =>
          userProjectsHasProjectManagement.value.includes(it.projectId)
        );

        const updateAccountRightsRequest: UpdateEmployerAccountRightsOtherCommand = {
          accountId: userId || 0,
          rights: rightsToSubmit,
        };
        api
          .employerAccountManagementUpdateOtherAccountRights(
            updateAccountRightsRequest
          )
          .then(() => {
            // Return to user account overview
            router.push({ name: "user-management" });
          });
      }
    }

    async function createUser() {
      const request: AddEmployerAccountCommand = {
        firstName: userForm.fields.firstName,
        middleName: userForm.fields.middleName,
        lastName: userForm.fields.lastName,
        emailAddress: userForm.fields.emailAddress,
        // Combine current and remaining project rights
        rights: [
          currentProjectRights.value as EmployerAccountRightsDto,
          ...(projectRights.value || []),
        ],
      };
      api
        .employerAccountManagementAddEmployerAccount(request)
        .then(() => {
          // Return to user account overview
          router.push({ name: "user-management" });
        })
        .catch((err) => {
          userForm.errors = err.response.data.errors;
        });
    }

    async function addRightToExistingAccount() {
      api
        .employerAccountManagementAddRightsToExistingAccount({
          accountId: userId || 0,
          newRight: currentProjectRights.value as EmployerAccountRightsDto4,
        })
        .then(() => {
          // Return to user account overview
          router.push({ name: "user-management" });
        })
        .catch(() => {
          vm.root.$emit(
            "snackbar",
            "Er is een fout opgetreden bij het bijwerken van de projectrechten"
          );
        });
    }

    async function onSubmit() {
      if (userForm.isValid && mode.value === Mode.NEW) {
        // New user
        await createUser();
      } else if (
        userForm.isValid &&
        mode.value === Mode.APPEND_PROJECTRIGHT_TO_EXISTING
      ) {
        await addRightToExistingAccount();
      } else if (userForm.isValid) {
        // Update user
        await updateUser();
      }
    }

    function getCurrentProjectId() {
      return Store.getters["User/getSelectedProject"].projectId || undefined;
    }

    function getCurrentProject() {
      return Store.getters["User/getSelectedProject"];
    }

    async function getEmployer(id: number | null): Promise<void> {
      let { accountId } = Store.getters["User/getUser"];

      if (accountId !== id) {
        accountId = id;
        // Editing someone else's account
        ownAccount.value = false;
      }
      await api
        .employerAccountManagementGetEmployer(accountId)
        .then((response) => {
          userData.value = response.data;

          // Determine current project and set isEnabled to true
          currentProjectRights.value = userData.value.rights
            ?.filter((rights) => rights.projectId === getCurrentProjectId())
            .map((rights) => {
              return {
                ...rights,
                isEnabled: true,
                authorize: rights.authorize || false,
                userManagement: rights.userManagement || false,
                confirmationMails: rights.confirmationMails || false,
                subscriptionCopy: rights.subscriptionCopy || false,
                deleteUser: false,
              } as RightsTable;
            })[0];

          // Determine remaining projects
          projectRights.value = userData.value.rights
            ?.filter((rights) => rights.projectId !== getCurrentProjectId())
            .map((rights) => {
              return {
                ...rights,
                isEnabled:
                  rights.authorize ||
                  rights.userManagement ||
                  rights.confirmationMails ||
                  rights.subscriptionCopy ||
                  false,
                authorize: rights.authorize || false,
                userManagement: rights.userManagement || false,
                confirmationMails: rights.confirmationMails || false,
                subscriptionCopy: rights.subscriptionCopy || false,
                deleteUser: false,
              } as RightsTable;
            });
        });
    }

    function getProjectById(id: number) {
      const project = allProjects.value.filter((p) => p.projectId === id);
      return project.length ? project[0].projectNumber : "Onbekend";
    }

    function checkProjectRights(index?: number) {
      let rights = currentProjectRights.value;
      if (index !== undefined) {
        rights = projectRights.value && projectRights.value[index];
      }

      if (!rights) {
        vm.root.$emit(
          "snackbar",
          "Something went wrong, please try again later",
          "warning"
        );
        return;
      }

      // If all setting are unchecked, isEnabled is set to false and delete is set to true.
      if (
        rights.authorize === false &&
        rights.confirmationMails === false &&
        rights.userManagement === false &&
        rights.subscriptionCopy === false
      ) {
        rights.deleteUser = true;
        rights.isEnabled = false;
      } else {
        rights.deleteUser = false;
        rights.isEnabled = true;
      }
    }

    function checkProjectRightsEnabled(index?: number) {
      let rights = currentProjectRights.value;
      if (index !== undefined) {
        rights = projectRights.value && projectRights.value[index];
      }
      // If isEnabled is false, disable all checkboxes
      if (rights && !rights?.isEnabled) {
        // Show message that user can't login whilst this is disabled
        vm.root.$emit("snackbar", i18n.t("user.notice"), "warning");
        rights.authorize = false;
        rights.confirmationMails = false;
        rights.userManagement = false;
        rights.subscriptionCopy = false;
        rights.deleteUser = true;
      }
    }

    function checkAvailableUsers() {
      const users = availableUsers.value.filter((it) => {
        const found =
          userForm.fields.emailAddress &&
          it.emailAddress === userForm.fields.emailAddress;
        if (found) {
          userForm.fields.firstName = it.firstName ?? "";
          userForm.fields.lastName = it.lastName ?? "";
          userForm.fields.middleName = it.middleName ?? "";
        }
        return found;
      });
      userFound.value = users.length > 0 ? users[0] : undefined;

      showUserFoundDialog.value = users.length > 0;
    }

    async function getProjectManagement() {
      const {
        data,
      } = await api.employerAccountManagementGetUserProjectsHasProjectManagement();
      userProjectsHasProjectManagement.value = data;
    }

    async function getProjectAccountsOfProjectAccount() {
      const {
        data,
      } = await api.employerAccountManagementGetProjectAccountsOfProjectAccount(
        getCurrentProjectId()
      );

      availableUsers.value = data;
      autoComplete.value = data.map(
        (it) =>
          ({
            email: it.emailAddress,
            firstName: it.firstName,
            lastName: it.lastName,
            disabled: false,
          } as AutoCompleteItem)
      );
    }

    async function createRightsTable() {
      projectRights.value = [];
      allProjects.value.forEach((proj) => {
        if (
          proj.projectId === Store.getters["User/getSelectedProject"].projectId
        ) {
          // This is the current project
          currentProjectRights.value = {
            projectId: proj.projectId || 0,
            isEnabled: true,
            authorize: false,
            confirmationMails: false,
            userManagement: false,
            subscriptionCopy: false,
            projectName: proj.name,
            deleteUser: false,
          };
        } else {
          const rt = {
            projectId: proj.projectId || 0,
            projectName: proj.name,
            isEnabled: false,
            authorize: false,
            confirmationMails: false,
            userManagement: false,
            subscriptionCopy: false,
            deleteUser: false,
          } as RightsTable;
          if (projectRights.value) {
            projectRights.value.push(rt);
          }
        }
      });

      await getProjectAccountsOfProjectAccount();
    }

    async function loadUser(id: number) {
      await getEmployer(id);
      await getProjectManagement();

      // Do not show "null" when no name is present.
      let contactName = "";
      if (userData.value.firstName && userData.value.lastName) {
        if (userData.value.middleName) {
          contactName = `${userData.value.firstName} ${userData.value.middleName} ${userData.value.lastName}`;
        }
        contactName = `${userData.value.firstName} ${userData.value.lastName}`;
      }

      mode.value = Mode.EDIT;
      userForm.fields.firstName = userData.value.firstName || "";
      userForm.fields.middleName = userData.value.middleName || "";
      userForm.fields.lastName = userData.value.lastName || "";
      userForm.fields.emailAddress = userData.value.emailAddress || "";
      userForm.fields.customSignature = userData.value.customSignature || false;
      userForm.fields.signatureLine1 = userData.value.signatureLine1 || "";
      userForm.fields.signatureLine2 = userData.value.signatureLine2 || "";
      userForm.fields.isAccountActive = !userData.value.isDisabled;

      if (userForm.fields.customSignature === false) {
        userForm.fields.signatureLine1 = contactName;
        userForm.fields.signatureLine2 = userData.value.emailAddress || "";
      }
    }

    async function assignAccount() {
      if (!userFound.value?.accountId) {
        return;
      }

      if (userFound.value?.firstName) {
        userForm.fields.firstName = userFound.value.firstName;
      }
      if (userFound.value?.lastName) {
        userForm.fields.lastName = userFound.value.lastName;
      }
      if (userFound.value?.emailAddress) {
        userForm.fields.emailAddress = userFound.value.emailAddress;
      }

      userId = userFound.value?.accountId;
      allProjects.value = Store.getters["User/getProjects"];
      await loadUser(userId);

      const currentProject = getCurrentProject();

      // This is the current project
      currentProjectRights.value = {
        projectId: currentProject.projectId || 0,
        isEnabled: true,
        authorize: false,
        confirmationMails: false,
        userManagement: false,
        subscriptionCopy: false,
        projectName: currentProject.name,
        deleteUser: false,
      };

      projectRights.value = undefined;

      mode.value = Mode.APPEND_PROJECTRIGHT_TO_EXISTING;
      // cancel dialog
      showUserFoundDialog.value = false;
    }

    onMounted(async () => {
      userId = parseInt(vm.root.$route.params.id, 0) || null;
      allProjects.value = Store.getters["User/getProjects"];
      // If the page is in 'Edit' mode, prefill the form with user data
      if (userId) {
        await loadUser(userId);
      } else {
        await getProjectManagement();
        await createRightsTable();
      }
    });

    return {
      allProjects,
      currentProjectRights,
      getProjectById,
      Mode,
      mode,
      onSubmit,
      ownAccount,
      userRights,
      projectRights,
      mapValidationErrors,
      userForm,
      checkProjectRights,
      checkProjectRightsEnabled,
      checkAvailableUsers,
      userFound,
      hasUserFound: showUserFoundDialog,
      assignAccount,
      availableUsers,
      autoComplete,
      userProjectsHasProjectManagement,
    };
  },
});
